import React, { Component } from 'react';
import { connect } from 'react-redux';
//utils
import { Translations, isEmptyObject } from '../../../../utils';
// children
import { PoolList, StandaloneList } from './GlsNotionalPoolingStrucutre/';
import { eapiClient, aemHostClient, taxonomyHostClient } from '../../../../restClient';
import SimpleDropdown from '../../../common/SimpleDropdown';
// import  AddPool  from './GlsNotionalPoolingStrucutre/AddPool/'
// import  AddStandalone  from './GlsNotionalPoolingStrucutre/AddStandalone/'

class GlsNotionalPoolingStrucutre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pools: [],
      countries: [],
      countryOfSow: (this.props.selectedSowProduct && this.props.selectedSowProduct.location) || {},
      selectedSowProduct: this.props.selectedSowProduct,
      hasCountryChanged: true
    }
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  componentWillMount() {
    this.getCountryList()
  }

  componentDidMount() {
    const { pools = [], standAloneAccount = [] } = (this.props.selectedSowProduct && this.props.selectedSowProduct.notionalPooling &&
      this.props.selectedSowProduct.notionalPooling.poolingStructure) || {}


    if ((this.props.selectedSowProduct && this.props.selectedSowProduct.location) || pools.length || standAloneAccount.length) {
      this.setState({ hasCountryChanged: false });
    }
  }





  setLocationData = (event) => {
    let _countryOfSow = {
      name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
      value: event.target.value
    }
    this.setState({ hasCountryChanged: true, countryOfSow: _countryOfSow });
    this.props.setCountryOfSow && this.props.setCountryOfSow(_countryOfSow)
  }

  checkCountryDisabled = () => {
    const { pools = [], standAloneAccount = [] } = (this.props.selectedSowProduct && this.props.selectedSowProduct.notionalPooling &&
      this.props.selectedSowProduct.notionalPooling.poolingStructure) || {}
    return (pools.length || standAloneAccount.length)
  }

  getCountryList = () => {
    const apiUrl = '/product/taxonomies/notionPoolingCountries'
    eapiClient(apiUrl)
      .then(({ data }) => {
        if (data.responseData) {
          this.setState({
            countries: data.responseData.classificationNodes
          });
        }
      });
  }

  render() {

    const { pageJson, pageJson1
    } = this.props;

    const editPoolEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/sow-body/sow-product-notional-pooling/add-pool/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'edit',
            productId: productId,
            isNavigate: this.props.isNavigate
          }
        });
      } else {
        alert("something went wrong")
      }

    }

    const addPoolEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/sow-body/sow-product-notional-pooling/add-pool/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'add',
            productId: productId,
            isNavigate: this.props.isNavigate
          }
        });
      } else {
        alert("something went wrong")
      }
    }

    const editStandaloneEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/sow-body/sow-product-notional-pooling/add-standalone/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'edit'
          }
        });
      } else {
        alert("something went wrong")
      }
    }

    const addStandaloneEvent = (event, id = null) => {
      let CaseId = this.props.match.params.caseId || '';
      let productId = this.props.match.params.productId || '';
      if (CaseId && productId) {
        this.props.history.push({
          pathname: `/sow-body/sow-product-notional-pooling/add-standalone/${CaseId}/${productId}/`,
          state: {
            statuses: this.props.statuses,
            currency: this.props.currency,
            id: id,
            mode: 'add'
          }
        });
      } else {
        alert("something went wrong")
      }
    }

    const handleNotionalPoolData = (event, id = null) => {
      if (this.props.selectedSowProduct) {
        // const { glsId } = (this.props.match && this.props.match.params) || {}
        const apiUrl = `/sows/${this.props.selectedSowProduct.id}/glses`;
        const selectedSowProduct = this.props.selectedSowProduct;
        const payload = {
          ...selectedSowProduct,
          location: this.state.countryOfSow,
        }
        payload.notionalPooling.interestOptimisations = selectedSowProduct.notionalPooling && Array.isArray(selectedSowProduct.notionalPooling.interestOptimisations) &&
          selectedSowProduct.notionalPooling.interestOptimisations.length ? selectedSowProduct.notionalPooling.interestOptimisations : null;
        this.props.blockUi && this.props.blockUi()
        eapiClient(apiUrl, {
          method: 'PUT',
          data: JSON.stringify(payload)
        }).then(({ data }) => {
          this.props.unBlockUi && this.props.unBlockUi()
          // this.getSweepInstructionList();
          this.setState({ hasCountryChanged: false });
          if (!isEmptyObject(data.responseData)) {
            this.props.setSowSelectedProduct(data.responseData)
          }

        })
      }

    }

    return (
      <div>
        {/* <div className="gdocs-banner msgblue">
          <i className="icon icon-circle-error-solid msgblue"></i>
          <span>{this.translations(pageJson.notificationText)}</span>
        </div> */}

        <div className="form-row">
          <div className="form-column">
            <label>{this.translations(pageJson.guidedropdownlist_location && pageJson.guidedropdownlist_location.title)}</label>
          </div>
          <div className="form-column">
            <SimpleDropdown
              name="countryOfSow"
              options={this.state.countries || []}
              optionTextSelector="name"
              showPleaseSelectOption={true}
              disabled={this.checkCountryDisabled()}
              value={this.state.countryOfSow.value || ''}
              _onChange={this.setLocationData}
              defaultValue={this.translations(pageJson.guidedropdownlist_location && pageJson.guidedropdownlist_location._value)}
            />
          </div>
        </div>
        <PoolList
          {...this.props}
          editPoolEvent={editPoolEvent}
          lang={this.props.lang}
        />
        <StandaloneList
          {...this.props}
          editStandaloneEvent={editStandaloneEvent}
          lang={this.props.lang}
        />
        <div className="form-buttons-wrapper">
          <button disabled={this.state.hasCountryChanged || this.props.customer.roleDetails.customer || !(this.state.countryOfSow && this.state.countryOfSow.value)} aria-label={this.translations(pageJson.addPoolBtnText)} onClick={addPoolEvent}>{this.translations(pageJson.addPoolBtnText)}</button>
          <button disabled={this.state.hasCountryChanged || this.props.customer.roleDetails.customer || !(this.state.countryOfSow && this.state.countryOfSow.value)} aria-label={this.translations(pageJson.addStandaloneAccBtnText)} onClick={addStandaloneEvent}> {this.translations(pageJson.addStandaloneAccBtnText)}</button>
        </div>
        <section className='btn-submit-container'>
          <button className="gdocs-btn-submit" onClick={handleNotionalPoolData} disabled={this.props.isReadOnly && this.props.isReadOnly()}>Refresh</button>
        </section>
      </div>
    );
  }

}

const mapStateToProps = state => ({
  lang: state.lang,
  customer: state.auth.userDetails,
  selectedSowProduct: (state.sowEntities && state.sowEntities.selectedSowProduct) || {},
  sowId: state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.sowId,
})

export default connect(mapStateToProps, null)(GlsNotionalPoolingStrucutre);



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/NotionalPoolSummary/GlsNotionalPoolingStrucutre.js